import type { ApiEnvelope } from '../../domain/types';
import { parseEnvelope } from './parseEnvelope';

/** Parse GitHub BFF JSON envelopes; preserve error.code for Settings CTA. */
export async function parseGithubEnvelope<T>(response: Response): Promise<ApiEnvelope<T>> {
  return parseEnvelope<T>(response, undefined, 'GITHUB_HTTP_ERROR');
}
